import React from 'react';

const NusmaHeroSection = ({ 
  onNavigateToDemo = () => {}, 
  onNavigateToProducts = () => {} 
}) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-black to-gray-950 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-72 h-72 bg-red-600 rounded-full mix-blend-multiply filter blur-xl animate-pulse"></div>
        <div className="absolute top-40 right-20 w-72 h-72 bg-red-900 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-1000"></div>
        <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-red-700 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-2000"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-gray-800/80 backdrop-blur-sm border border-red-900 text-red-300 text-sm font-medium mb-8 shadow-lg">
            <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
            </svg>
            Líder en Soluciones de IA para Cumplimiento Normativo
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Revoluciona tus
            <span className="bg-gradient-to-r from-red-600 to-red-900 bg-clip-text text-transparent"> Auditorías de Cumplimiento Normativo</span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
            Automatiza procesos de auditoría interna, reduce tiempos de evaluación en un 80% y garantiza el cumplimiento normativo con nuestro agente virtual especializado en ISO 27001.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <button
              onClick={onNavigateToDemo}
              className="w-full sm:w-auto bg-gradient-to-r from-red-600 to-red-900 text-white px-8 py-4 rounded-2xl text-lg font-semibold shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
            >
              Solicitar Demo Gratuita
            </button>
            <button
              onClick={onNavigateToProducts}
              className="w-full sm:w-auto bg-gray-800 text-gray-200 px-8 py-4 rounded-2xl text-lg font-semibold border border-gray-700 shadow-lg hover:shadow-xl hover:bg-gray-700 transition-all duration-300"
            >
              Ver Productos
            </button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-3xl mx-auto">
            <div className="bg-gray-800/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-gray-700">
              <div className="text-3xl font-bold text-red-500 mb-2">80%</div>
              <div className="text-gray-300 text-sm">Reducción en tiempo de auditoría</div>
            </div>
            <div className="bg-gray-800/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-gray-700">
              <div className="text-3xl font-bold text-red-600 mb-2">500+</div>
              <div className="text-gray-300 text-sm">Empresas en Latinoamérica</div>
            </div>
            <div className="bg-gray-800/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-gray-700">
              <div className="text-3xl font-bold text-red-700 mb-2">99.9%</div>
              <div className="text-gray-300 text-sm">Precisión en cumplimiento</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>
  );
};

export default NusmaHeroSection;